import { i18n } from "../../i18n";
import { CartItemView } from "../../../types";
import { EnergyLabel } from "../EnergyLabel";

declare let window: ProductPage;

interface ProductCartRowProps {
  item: CartItemView;
  quantity?: number;
}

export const ProductCartRow = ({ item, quantity }: ProductCartRowProps) => {
  const { imageUrlSmall, price, shipping, title } = item;

  return (
    <div class="row modal-product-details">
      <div class="col-2 d-none d-sm-block">
        {imageUrlSmall && (
          <img src={imageUrlSmall} class="product-image" aria-hidden={true} />
        )}
      </div>
      <div class="col-12 col-sm-10 row">
        <em class="col-2 col-sm-1 p-sm-0 mr-sm-2 tw:whitespace-nowrap">
          {quantity ? `${quantity} x` : "1 x"}
        </em>
        <div class="col row pr-0">
          <div class="col-12 col-sm p-0">
            <span
              class="modal_product_title"
              data-testid="add-to-cart-modal-product-title"
            >
              {title ?? i18n("product.details")}
            </span>
            {shipping.freeShippingAvailable && (
              <span class="savings_shipping_small d-block free_shipping">
                {i18n("product.free.shipping")}
              </span>
            )}
            {price.taxCalculationRequiredInCheckout === true && (
              <small class="text-muted">{i18n("product.tax.checkout")}</small>
            )}
            {window.enableEnergyLabels && item.eprelId && (
              <div>
                <EnergyLabel eprelId={item.eprelId} />
              </div>
            )}
          </div>
          <div class={`col-12 col-sm-7 p-0 pl-sm-2 pr-sm-0 cost`}>
            {price.discounted && price.formattedRrp && (
              <p class="cost__rrp">
                {i18n("product.recommendedPrice")}
                <del> {price.formattedRrp}</del>
              </p>
            )}
            {price.discounted && price.formattedDiscountPercentage && (
              <p class="savings_shipping_small d-block">
                -{price.formattedDiscountPercentage}
              </p>
            )}
            <p>
              {i18n("product.price")}{" "}
              <span
                class="cost__price"
                data-testid="add-to-cart-modal-product-price"
              >
                {price.formattedDisplayPrice}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
